import { Col } from 'antd'

function ANTDColumn({ ...props }) {
  return <Col {...props} />
}

export default ANTDColumn
